import { render } from "./HomeFurnishing.vue?vue&type=template&id=0f02d32b"
import script from "./HomeFurnishing.vue?vue&type=script&lang=js"
export * from "./HomeFurnishing.vue?vue&type=script&lang=js"

import exportComponent from "/home/psinclair/git/hitting-the-target-australia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__